import { IUploadFilesParams } from 'core/model/interfaces/upload-files';
import { uploadFilesData } from './upload-file.data';
import { mapFilesToFormData, mapFilesToFormDataResponse } from './upload-files.mapper';

export const uploadFilesService = {
  uploadFiles: async (body: IUploadFilesParams) => {
    const formData = mapFilesToFormData(body.images);

    const response = await uploadFilesData.uploadFiles(formData);

    const encodedResponse = mapFilesToFormDataResponse(response);

    return encodedResponse;
  },
};
